import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin, isAdmin, api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    if (isAdmin()) {
      api.get("/admin/verify").then(() => nav("/hana/dashboard/panel")).catch(() => localStorage.removeItem("hana_admin_token"));
    }
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await adminLogin(username, password);
      nav("/hana/dashboard/panel");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Identifiants invalides");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-primary flex items-center justify-center px-6 seigaiha">
      <div className="bg-background w-full max-w-md p-10 rounded-sm">
        <div className="text-center mb-8">
          <div className="w-14 h-14 bg-primary text-white rounded-full mx-auto flex items-center justify-center mb-4">
            <Lock size={22} />
          </div>
          <h1 className="font-display text-3xl text-foreground">Espace administration</h1>
          <p className="text-muted-foreground text-sm mt-1">Hanamiya Ramen — accès réservé</p>
        </div>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label className="text-xs uppercase tracking-wider text-muted-foreground mb-2 block">Nom d'utilisateur</Label>
            <Input data-testid="admin-username" value={username} onChange={(e) => setUsername(e.target.value)} className="h-12 rounded-sm" autoFocus />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider text-muted-foreground mb-2 block">Mot de passe</Label>
            <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 rounded-sm" />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-primary text-white py-3 rounded-sm hover:bg-primary/90 disabled:opacity-60"
          >
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
